/**
 * @description Gestion des fontions communes aux pages du site
 */

/* global bsBreakpoints */

(() => {
	// FONCTIONS
	// Savoir quand la page est chargée
	const loaded = () => {
		document.addEventListener('DOMContentLoaded', () => {
			document.body.classList.add('loaded');
			bsBreakpoints.init();
		});
	};

	const deleteEmpty = (html) => {
		document.querySelectorAll(html).forEach((el) => {
			const content = el.innerHTML;
			if (content === null || content === undefined || content === '') {
				el.remove();
			}
		});
	};
	const adaptativeFooter = () => {
		const h = window.innerHeight;
		const main = document.querySelector('main');
		const footerHeight = document.querySelector('.footer')
			? document.querySelector('.footer').offsetHeight - 0.5
			: 0;
		const headerHeight = document.querySelector('header').offsetHeight;
		const sum = footerHeight + headerHeight;
		if (main.offsetHeight < h) {
			main.setAttribute(
				'style',
				'position:relative; min-height:calc(100vh - ' + sum + 'px);'
			);
		}
	};

	const byPassLinks = () => {
		const byPassLinks = document.querySelector('.bypass-links');
		if (byPassLinks) {
		const isMixte = document.querySelector('.header__mixte')|| null;

			document.addEventListener('keyup', function (e) {
				setTimeout(() => {
					if (
						document.activeElement.classList.contains('bypass-link')
					) {
						byPassLinks.classList.remove('visually-hidden');
					} else {
						byPassLinks.classList.add('visually-hidden');
					}
				}, 0);
			});

			const goToAnchor = (link, e) => {
				const attr = link.getAttribute('href');
				if (attr === '#edit-text') {
					const search = document.querySelector(
						'.header__search input[type="text"]'
					);
					const searchContainer = document.querySelector(
						'.header__search .views-exposed-form'
					);
					const searchToggle = document.querySelector(
						'.header__search [data-js-header-search-toggle]'
					);

					e.preventDefault();

					if (
						searchToggle.getAttribute('aria-expanded') === 'false'
					) {
						searchToggle.click();
					}
					search.focus();
				} else if (attr === '#block-spe-main-menu') {
					e.preventDefault();
					document
						.querySelector(attr)
						.querySelector('.first a')
						.focus();
				}
				byPassLinks.classList.add('visually-hidden');
			};

			const removeRelative = (gabarit) => {
				if(gabarit){
					gabarit.querySelector('.header').classList.remove('header--relative');
				}
			}
			byPassLinks.querySelectorAll('a').forEach((link,index) => {
				link.addEventListener('keydown', function (e) {
					if(isMixte){
						isMixte.querySelector('.header').classList.add('header--relative');
					}
					if (e.key === 'Enter') {
						goToAnchor(link, e);
						removeRelative(isMixte)
					}
					if (e.key === 'Escape') {
						const focusable = document
							.querySelector('.header')
							.querySelectorAll(
								'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
							);
						focusable[0].focus();
						byPassLinks.classList.add('visually-hidden');
						removeRelative(isMixte)
					}
					if(e.key === "Tab" && index === byPassLinks.querySelectorAll('a').length - 1 ){
						removeRelative(isMixte)
					}
				});

				link.addEventListener('click', function (e) {
					goToAnchor(link, e);
				});
			});

			// On rajoute un element si on est sur la page de modalités de cookies pour ouvrir rapidement le bouton de paramètres cookies
			const ifCookies = document.querySelector('[data-set-cookies]') || null;
			if(ifCookies){
				byPassLinks.insertAdjacentHTML('beforeend',`<li><a href="/" class="bypass-link bypass-link--cookies">Ouvrir les préférences de cookies</a></li>`)
				const getCookie = document.querySelector('.bypass-link--cookies');
				getCookie.addEventListener('keydown',(e)=>{
					e.preventDefault();
					if(e.key === "Enter"){
						ifCookies.click();
						document.querySelector('.cookies').focus();
					}
				})
			}
		}
	};

	// GO 🚀
	const init = () => {
		loaded();
		// deleteEmpty('p');
		// deleteEmpty('li');
		adaptativeFooter();
		byPassLinks();
	};

	init();
})();
